export const GOLANG = 'Golang';
export const I_OS = 'iOS';
export const JAVA = 'Java';
export const MAC_OS = 'Objective-C';
export const PYTHON = 'Python';
export const WEB = 'HTML/CSS';
export const UNITY = 'Unity';